import basicDyxVue from './basicDyx.vue';
export default {
  components: {
    basicDyxVue: basicDyxVue
  }
};